import o from "./HeaderListbox.vue2.js";
import "./HeaderListbox.vue3.js";
import t from "../../_virtual/_plugin-vue_export-helper.js";
const m = /* @__PURE__ */ t(o, [["__scopeId", "data-v-d0411a45"]]);
export {
  m as default
};
